var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _ = require("lodash");

var plugin = require("tailwindcss/plugin");

module.exports = plugin(function (_ref) {
  var addUtilities = _ref.addUtilities,
      theme = _ref.theme,
      e = _ref.e,
      variants = _ref.variants;

  var utilities = _.map(theme("lineClamp"), function (value, key) {
    return _defineProperty({}, ".".concat(e("clamp-".concat(key))), {
      overflow: "hidden",
      display: "-webkit-box",
      "-webkit-line-clamp": "".concat(value),
      "-webkit-box-orient": "vertical"
    });
  });

  addUtilities(utilities, variants("lineClamp", []));
}, {
  theme: {
    lineClamp: {
      "1": 1,
      "2": 2,
      "3": 3
    }
  }
});